// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 168) return "static/chunks/168.90ccc0d26e09c2a6.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"79":"6cb168b6fc918d29","915":"dfba538dba22ce41"}[chunkId] + ".js";
};